import { LegacySensor, SensorMeta, fetchSensorAPI, rootApiUrl } from "../jefdaqLegacyAPI";

export interface StageApiSensor extends LegacySensor {
  site: string;
  lastReport: string | null;
  latitude: number;
  longitude: number;
  name: string;
  source: string;
  null: number;
  stage: number | null;
  stages: (number | null)[];
  times: (string | null)[];
  unitLong: string;
  unitShort: string;
}

export interface StageApiMeta extends SensorMeta {
  periodsSeconds: number[];
  timezone: string;
}

export interface StageApiResponse {
  meta: StageApiMeta;
  data: StageApiSensor[];
}

const url = rootApiUrl + "/json/stage/"
const check = /[feet|in]/i;

export const fetchStageAPI = () => fetchSensorAPI<StageApiMeta, StageApiSensor>(url, check);
